<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Tra cứu công việc giảng dạy</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu
                </button>
                <button class="btn btn-success btn-sm" (click)="Excel()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-file-excel"></i> Xuất excel 
                </button>
                <!-- <button class="btn btn-warning btn-sm" type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button> -->
            </div>
        </div>
    </div>
</section>

<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa học</label>
                        <select class="form-control" formControlName="Khoa_hoc">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Học kỳ</label>
                        <select class="form-control" formControlName="Hoc_ky">
                            <option value="0">Tất cả</option>
                            <option value="1">Học kỳ I</option>
                            <option value="2">Học kỳ II</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Năm học</label>
                        <select class="form-control" formControlName="Nam_hoc">
                            <option *ngFor="let i of Nam_hoc_arr" value="{{i.value}}">{{i.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Bộ môn</label>
                        <select class="form-control" formControlName="iD_bm">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataBoMon" value="{{i.ID_bm}}">{{i.Bo_mon}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Nhóm công việc</label>
                        <select class="form-control" formControlName="iD_nhom_cong_viec" (change)="changeNhomCongViec()">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataNCV" value="{{i.ID_nhom_cong_viec}}">{{i.Ten_nhom_cong_viec}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Công việc</label>
                        <select class="form-control" formControlName="iD_cong_viec">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataCV2" value="{{i.ID_cong_viec}}">{{i.Ten_cong_viec}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Loại lớp</label>
                        <select class="form-control" formControlName="iD_loai_lop">
                            <option value="0">Tất cả</option>
                            <option *ngFor="let i of dataLoaiLop" value="{{i.ID_loai_lop}}">{{i.Ten_loai_lop}}
                            </option>
                        </select>
                    </div>
                    <!-- <div class="col-md-2">
                        <label>Tên Lớp</label>
                        <input type="text" class="form-control" formControlName="ten_lop">
                    </div> -->


                    <div class="col-md-2">
                        <label class="col-md-12 ">Lớp</label>
                        <ng-select (change)="getList()" formControlName="ten_lop" placeholder="Chọn lớp">
                            <ng-option [value]="0">Tất cả</ng-option>
                            <ng-option *ngFor="let item of listClass" [value]="item.Ten_lop">{{item.Ten_lop}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-md-2">
                        <label>Tên môn học</label>
                        <input type="text" class="form-control" formControlName="ten_mon">
                    </div>
                    <div class="col-md-2">
                        <label>Giảng viên</label>
                        <input type="text" class="form-control" formControlName="giang_vien">
                    </div>                  
                </div>
            </form>
        </div>
    </div>
</section>

<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-fixed" style="width: 185%;">
                    <thead>
                        <tr>
                            <th>Mã GV</th>
                            <th>Họ và tên</th>
                            <th>Tên khoa</th>
                            <th>Bộ môn</th>
                            <th>Tên công việc</th>
                            <th>Tên môn/Nội dung công việc</th>
                            <th>Lớp/Phòng</th>
                            <th>Loại lớp</th>
                            <th>Số sv</th>
                            <th>Chức danh</th>
                            <th>Số giờ gốc</th>
                            <th>Đơn vị tính</th>
                            <th>Tổng hệ số</th>
                            <th>Số giờ quy đổi</th>
                            <th>Từ ngày</th>
                            <th>Đến ngày</th>
                            <th>Định mức giảng dạy</th>
                            <th>Định mức khoa học</th>
                            <th>Định mức chuyên môn</th>
                            <th>Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of dataTable">
                            <td>{{i.Ma_cb}}</td>
                            <td>{{i.Ho_ten}}</td>
                            <td>{{i.Ten_khoa}}</td>
                            <td>{{i.Bo_mon}}</td>
                            <td>{{i.Ten_cong_viec}}</td>
                            <td>{{i.Ten_mon}}</td>
                            <td>{{i.Ten_lop}}</td>
                            <td>{{i.Ten_loai_lop}}</td>
                            <td>{{i.So_sv|number}}</td>
                            <td>{{i.Chuc_danh}}</td>
                            <td>{{i.So_gio_goc|number}}</td>
                            <td>{{i.Don_vi_tinh}}</td>
                            <td>{{i.He_so_cong_viec + i.He_so_chuc_danh + i.He_so_he + i.He_so_loai_lop + i.He_so_lop + i.He_so_mon + i.He_so_ngoai_gio + i.He_so_ngoai_truong|number}}</td>
                            <td>{{i.So_gio_chuan|number}}</td>
                            <td>{{i.Tu_ngay|date:'dd/MM/yyyy'}}</td>
                            <td>{{i.Den_ngay|date:'dd/MM/yyyy'}}</td>
                            <td>{{i.Dinh_muc_giang_day}}</td>
                            <td>{{i.Dinh_muc_khoa_hoc}}</td>
                            <td>{{i.Dinh_muc_chuyen_mon}}</td>
                            <td>{{i.Ghi_chu}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <span style="float:right"><b>Tổng số bản ghi</b>: {{recordTotal|number}}</span> -->

        </div>
    </div>
</section>